import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Mail } from "lucide-react";

export default function Gracias() {
  useEffect(() => {
    document.title = "¡Próxima parada: la masterclass!";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="hero" style={{ minHeight: "100vh" }}>
      <div className="hero-bg" />
      <div
        className="container fade-in"
        style={{ position: "relative", zIndex: 1, textAlign: "center" }}
      >
        <div
          style={{
            width: 96,
            height: 96,
            margin: "0 auto 1.6rem",
            borderRadius: "50%",
            background: "rgba(217,255,0,0.12)",
            border: "1px solid rgba(217,255,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 40px -8px rgba(217,255,0,0.5)",
          }}
        >
          <CheckCircle2 size={56} color="#d9ff00" strokeWidth={2.2} />
        </div>
        <div className="eyebrow-yellow" style={{ marginBottom: "0.8rem" }}>
          Plaza reservada
        </div>
        <h1 className="h1-hero" style={{ marginBottom: "1rem" }}>
          ¡Nos vemos
          <br />
          <span className="serif-italic hl-purple">en directo</span>!
        </h1>
        <p
          style={{
            color: "var(--text-dim)",
            maxWidth: 620,
            margin: "0 auto 2rem",
            fontSize: "1.05rem",
            lineHeight: 1.6,
          }}
        >
          He recibido tu registro para la masterclass de{" "}
          <strong>Ventas Virales</strong>. En unos minutos te llegará un email
          con el acceso y los detalles de la clase. También te escribiré por
          WhatsApp para que no se te pase. — Judit.
        </p>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            color: "#d9ff00",
            background: "rgba(217,255,0,0.06)",
            border: "1px solid rgba(217,255,0,0.3)",
            borderRadius: 999,
            padding: "0.55rem 1rem",
            fontSize: "0.85rem",
            marginBottom: "1.6rem",
          }}
        >
          <Mail size={14} /> Revisa tu bandeja de entrada y SPAM
        </div>
        <div>
          <Link to="/" className="btn-ghost">
            <ArrowLeft size={16} /> Volver a la página principal
          </Link>
        </div>
      </div>
    </div>
  );
}
